import { useLocation, useNavigate } from "react-router";
import { getContentKeyAccToLang } from "../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import dynamicfunction from "../../utils/dynamicfunction";
import { resetPassword } from "../../store/actions/authActions";

export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { TextWeight, isArabic } = dynamicfunction();

  const { authContent } = useSelector((state) => state.content);
  const { authLoading } = useSelector((state) => state.auth);

  const data = location?.state;

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      authContent?.web_reset_password?.data?.attributes,
      key,
      isArabic
    );
  };

  const handleResetPassword = (values) => {
    const apiData = {
      newPassword: values?.password,
      clientCode: data?.clientCode,
    };
    
    dispatch(resetPassword(apiData, navigate));
  };

  return {
    TextWeight,
    isArabic,
    getContentKey,
    authLoading,
    handleResetPassword,
    navigate,
  };
};
